<template>
  <section id="products" class="products">
    <div class="products__glow"></div>
    <div class="container">
      <div class="products__header">
        <span class="section-label">PRODUCTS</span>
        <h2 class="section-title">产品矩阵</h2>
        <p class="section-desc">覆盖专业创作、大众社区到引擎技术，满足不同层级创作者需求</p>
      </div>
      <div class="products__cards">
        <div class="product-card" v-for="(item, index) in products" :key="index">
          <div class="product-card__top">
            <div class="product-card__icon-wrap">
              <img :src="item.icon" :alt="item.title" class="product-card__icon" />
            </div>
            <h3 class="product-card__title">{{ item.title }}</h3>
            <p class="product-card__desc">{{ item.description }}</p>
          </div>
          <div class="product-card__image-wrap">
            <img :src="item.image" :alt="item.title" class="product-card__image" />
          </div>
          <a v-if="item.url" :href="item.url" target="_blank" rel="noopener noreferrer" class="product-card__btn">
            <span class="product-card__btn-text">了解更多</span>
          </a>
          <button v-else class="product-card__btn">
            <span class="product-card__btn-text">了解更多</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import paintbrushIcon from '@/assets/icons/paintbrush.svg'
import engineIcon from '@/assets/icons/engine.svg'
import pandaIcon from '@/assets/icons/panda.svg'
import card1Image from '@/assets/images/card1.png'
import card2Image from '@/assets/images/card2.png'
import card3Image from '@/assets/images/card3.png'

export default {
  name: 'ProductsSection',
  data() {
    return {
      products: [
        {
          title: '画世界 Pro',
          description: '专业级数字绘画工具，为插画师、原画师和美术从业者打造。丰富笔刷系统、高质量画布、强大图层功能，释放创作自由',
          icon: paintbrushIcon,
          image: card1Image,
          url: 'https://hsjpro.mojing.art/'
        },
        {
          title: '熊猫绘画',
          description: '轻量化绘画工具与创作者社区。轻松绘画、分享灵感、结识同好，让每一次创作都充满乐趣',
          icon: pandaIcon,
          image: card3Image,
          url: 'https://pandapaint.net/'
        },
        {
          title: '摸鲸绘画引擎',
          description: '高性能数字绘画引擎。GPU加速渲染、高性能画布支持、跨平台SDK，为开发者提供顶尖绘画能力',
          icon: engineIcon,
          image: card2Image
        }
      ]
    }
  }
}
</script>

<style scoped>
.products {
  position: relative;
  padding: 100px 0;
}

.products__glow {
  position: absolute;
  width: 450px;
  height: 450px;
  top: -200px;
  /* right: 10%; */
  left: 55%;
  border-radius: 50%;
  /* background: radial-gradient(circle, rgba(59, 130, 246, 0.25) 0%, rgba(59, 130, 246, 0.08) 40%, rgba(10, 10, 15, 0) 100%); */
  background: radial-gradient(circle, rgba(59, 130, 246, 0.15000000596046448) 0%, rgba(10, 10, 15, 0) 85%);
  filter: blur(40px);
  pointer-events: none;
}

.products__header {
  position: relative;
  z-index: 1;
  text-align: center;
  margin-bottom: 48px;
}

.section-label {
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 2px;
  color: #3B82F6;
  display: block;
  margin-bottom: 12px;
}

.section-title {
  font-family: 'Inter', sans-serif;
  font-size: 40px;
  font-weight: 700;
  color: #FFFFFF;
  margin-bottom: 12px;
}

.section-desc {
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 400;
  color: #9CA3AF;
  max-width: 520px;
  margin: 0 auto;
}

.products__cards {
  position: relative;
  z-index: 1;
  display: flex;
  gap: 24px;
  overflow-x: auto;
}

.product-card {
  flex: 1;
  min-width: 0;
  background-color: #141419;
  border-radius: 16px;
  padding: 32px;
  display: flex;
  flex-direction: column;
}

.product-card__top {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.product-card__top > .product-card__icon-wrap + .product-card__title,
.product-card__top > .product-card__title + .product-card__desc {
  margin-top: 20px;
}

.product-card__icon-wrap {
  width: 48px;
  height: 48px;
  background-color: #1E1E2A;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-card__icon {
  width: 24px;
  height: 24px;
}

.product-card__title {
  font-family: 'Inter', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #FFFFFF;
}

.product-card__desc {
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  color: #9CA3AF;
}

.product-card__image-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
}

.product-card__image {
  max-width: 340px;
  max-height: 221px;
  border-radius: 8px;
}

.product-card__btn,
a.product-card__btn {
  display: block;
  width: 120px;
  height: 40px;
  margin: 0 auto;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  background: transparent;
  cursor: pointer;
  line-height: 40px;
  text-align: center;
  transition: background-color 0.2s;
  padding: 0;
}

.product-card__btn:hover,
a.product-card__btn:hover {
  background-color: rgba(255, 255, 255, 0.08);
}

.product-card__btn-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #FFFFFF;
}

@media (max-width: 1024px) {
  .products {
    padding: 80px 0;
  }
  .products__glow {
    width: 350px;
    height: 350px;
    top: -120px;
    /* right: 8%; */
    left: 55%;
    border-radius: 50%;
    /* background: radial-gradient(circle, rgba(59, 130, 246, 0.25) 0%, rgba(59, 130, 246, 0.08) 40%, rgba(10, 10, 15, 0) 100%); */
    background: radial-gradient(circle, rgba(59, 130, 246, 0.15000000596046448) 0%, rgba(10, 10, 15, 0) 85%);
    filter: blur(30px);
  }
  .products__header {
    margin-bottom: 40px;
  }
  .product-card {
    padding: 24px;
  }
  .products__cards {
    gap: 16px;
  }
  .product-card__title {
    font-size: 20px;
  }
  .product-card__desc {
    font-size: 14px;
    line-height: 20px;
  }
  .product-card__image {
    max-width: 280px;
    max-height: 182px;
  }
}

@media (max-width: 768px) {
  .products {
    padding: 60px 0;
  }
  .products__glow {
    width: 280px;
    height: 280px;
    top: -120px;
    /* right: 5%; */
    left: 55%;
    border-radius: 50%;
    /* background: radial-gradient(circle, rgba(59, 130, 246, 0.25) 0%, rgba(59, 130, 246, 0.08) 40%, rgba(10, 10, 15, 0) 100%); */
    background: radial-gradient(circle, rgba(59, 130, 246, 0.15000000596046448) 0%, rgba(10, 10, 15, 0) 85%);
    filter: blur(20px);
  }
  .products__header {
    margin-bottom: 32px;
  }
  .products__cards {
    flex-direction: column;
    margin: 0;
  }
  .product-card {
    margin: 0 0 16px 0;
    padding: 20px;
  }
  .product-card:last-child {
    margin-bottom: 0;
  }
  .product-card__title {
    font-size: 18px;
  }
  .product-card__desc {
    font-size: 13px;
    line-height: 18px;
  }
  .product-card__image {
    max-width: 260px;
    max-height: 169px;
  }
  .product-card__btn,
  a.product-card__btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .products {
    padding: 48px 0;
  }
  .product-card {
    padding: 16px;
  }
}
</style>
